module.exports = __webpack_public_path__ + "img/hack-dark.5660ef1b.png";